<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
            <div class="page-breadcrumb d-sm-flex align-items-center mb-4">
                <div class="breadcrumb-title pe-3">Change Password</div>
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0);" routerLink="/dashboard"><i class="bx bx-home-alt"></i></a>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Change Password</li>
                        </ol>
                    </nav>
                </div>
                <div class="ms-auto">
                    <div class="btn-group ms-2" role="group">
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-8 col-xl-7">
                    <div class="card border-top border-0 border-4 border-brand">
                        <div class="card-body p-5">
                            <div class="card-title d-flex align-items-center">
                                <div><i class="bx bxs-user me-1 font-22 brand-color"></i>
                                </div>
                                <h5 class="mb-0 brand-color">Change Password</h5>
                            </div>
                            <hr>
                            <form [formGroup]="ResetData" class="row g-3">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="form-label m-0" for="Password">Old Password</label>
                                        <div class="input-with-ic">
                                            <input type="password" class="form-control" id="password-field" placeholder="***********" minlength="6" onkeyup="this.value=this.value.replace(/^\s+/g, '')" formControlName="old_password" [ngClass]="{ 'is-invalid': submitted && f.old_password.errors }">
                                            <span class="input-icon" (click)="showHide('.toggle-password')"> 
                                            <i class="bx bx-low-vision toggle-password" toggle="#password-field"></i> 
                                        </span>
                                        </div>
                                        <small id="" class="text-danger d-inline-block pt-2" *ngIf="submitted && f.old_password.errors">                                                     
                                            <div *ngIf="f['old_password'].errors['required']">Password is required</div>
                                            <div *ngIf="f['old_password'].errors['pattern']">Password must be at least 8 characters long and contain at least one special character, one uppercase letter, one lowercase letter, and one number.</div>
                                        </small>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="form-label m-0" for="Password">New Password</label>
                                        <div class="input-with-ic">
                                            <input type="password" class="form-control" id="password-field1" placeholder="***********" minlength="6" onkeyup="this.value=this.value.replace(/^\s+/g, '')" formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                                            <span class="input-icon" (click)="showHide('.toggle-password1')"> 
                                            <i class="bx bx-low-vision toggle-password1" toggle="#password-field1"></i> 
                                        </span>
                                        </div>
                                        <small id="" class="text-danger d-inline-block pt-2" *ngIf="submitted && f.password.errors">                                                     
                                            <div *ngIf="f['password'].errors['required']">Password is required</div>
                                            <div *ngIf="f['password'].errors['pattern']">Password must be at least 8 characters long and contain at least one special character, one uppercase letter, one lowercase letter, and one number.</div>
                                        </small>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="form-label m-0" for="ConfirmPassword">Confirm Password</label>
                                        <div class="input-with-ic">
                                            <input type="password" class="form-control" id="password-field2" placeholder="***********" minlength="6" onkeyup="this.value=this.value.replace(/^\s+/g, '')" formControlName="cpassword" [ngClass]="{ 'is-invalid': submitted && f.cpassword.errors }">
                                            <span class="input-icon" (click)="showHide('.toggle-password2')"> 
                                            <i class="bx bx-low-vision toggle-password2" toggle="#password-field2"></i> 
                                        </span>
                                        </div>
                                        <small id="" class="text-danger d-inline-block pt-2" *ngIf="submitted && f.cpassword.errors"> 
                                            <div *ngIf="f['cpassword'].errors['required']">Password is required</div>
                                            <div *ngIf="f['cpassword'].errors['pattern']">Password must be at least 8 characters long and contain at least one special character, one uppercase letter, one lowercase letter, and one number.</div>
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-btn-box">
                                        <button type="submit" class="btn custom-btn gradient1-btn px-4" (click)="Onsubmit()">Update</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>
